export default __webpack_public_path__ + "static/cryptickiller-6989051206e546d88b95a3481d37a9c1.jpg";